
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



  const cardData =
  {
    keyword: 'Urbania on Rent in Pune',
    heading: 'AB Ghule Cabs: Urbania on Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers premium Urbania rental services in Pune, providing you with a comfortable and spacious travel experience. Whether you are planning a family trip, a corporate outing, or a group event, our well-maintained Urbania vehicles are the perfect choice for long-distance journeys or city sightseeing. With a focus on comfort, safety, and affordable pricing, we ensure that your ride is stress-free and enjoyable.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Urbania on Rent in Pune',

   topPlaces: [
  {
    title: "Spacious and Comfortable Seating",
    description: "Our Urbania vehicles are designed with spacious interiors, offering ample legroom and comfortable seating for large groups. Perfect for family outings, corporate events, or group tours, ensuring a relaxed journey for everyone."
  },
  {
    title: "Affordable and Transparent Pricing",
    description: "We offer competitive rates for Urbania rentals with no hidden charges. Our pricing is clear and budget-friendly, ensuring you get the best value for your money."
  },
  {
    title: "Well-Maintained and Clean Vehicles",
    description: "All our Urbania vehicles are regularly serviced and maintained to ensure a smooth and comfortable ride. We also prioritize cleanliness, with every vehicle being sanitized before and after each trip for your safety."
  },
  {
    title: "Experienced and Professional Drivers",
    description: "Our drivers are well-trained professionals, skilled in navigating Pune's roads and offering a safe, smooth ride. They are familiar with popular tourist spots, ensuring your trip is hassle-free and enjoyable."
  },
  {
    title: "24/7 Availability",
    description: "Whether you need an Urbania for an early morning airport transfer, a late-night trip, or a weekend getaway, our rental service is available round-the-clock to meet your travel needs."
  },
  {
    title: "Customizable Packages",
    description: "We offer flexible packages for group tours, corporate events, family vacations, and more. Customize your trip based on duration, destinations, and services to meet your specific needs."
  },
  {
    title: "Ideal for Corporate and Group Travel",
    description: "The Urbania is the perfect vehicle for corporate events, business meetings, or group outings. It provides a comfortable setting for passengers to work, relax, or socialize during the journey."
  },
  {
    title: "Smooth and Safe Journey",
    description: "With AB Ghule Cabs, your safety is our priority. Our Urbania vehicles are equipped with modern safety features, and our experienced drivers ensure that you reach your destination safely and on time."
  },
  {
    title: "Easy Booking Process",
    description: "Booking an Urbania on rent with AB Ghule Cabs is simple and hassle-free. You can easily book your vehicle online or by phone, and our customer support team will assist you in planning your trip."
  },
  {
    title: "No Surge Pricing",
    description: "We do not engage in surge pricing. The price you are quoted is the price you pay, offering a transparent and honest rental experience."
  }
],


services: [
    {
      "name": "Luxury Force Urbania on Rent in Pune",
      description: "AB Ghule Cabs offers the luxury Force Urbania on rent in Pune, providing an ideal solution for group travel with spacious seating and modern amenities. Our Urbania vehicles ensure a comfortable and luxurious ride for both short and long-distance trips."
    },
    {
      "name": "13 Seater Force Urbania on Rent in Pune",
      description: "Need a 13-seater Force Urbania for your group travel? AB Ghule Cabs offers well-maintained, spacious 13-seater Force Urbania vehicles on rent in Pune, ensuring a comfortable and relaxed ride for your journey."
    },
    {
      "name": "17 Seater Force Urbania on Rent in Pune",
      description: "AB Ghule Cabs offers a 17-seater Force Urbania for rent in Pune. Perfect for group tours or corporate events, our 17-seater Urbania provides ample space and comfort for all passengers, ensuring a pleasant journey."
    },
    {
      "name": "Force Urbania for Rent in Pune",
      description: "Rent a Force Urbania from AB Ghule Cabs in Pune for a comfortable and spacious group trip. Our fleet includes both 13-seater and 17-seater options, ideal for long and short-distance travels."
    },
    {
      "name": "Pune to Mahabaleshwar Urbania Bus on Rent",
      description: "Planning a trip to Mahabaleshwar? Book a Force Urbania bus for rent from Pune with AB Ghule Cabs. Our Urbania buses provide the perfect balance of comfort and space for your group travel to this beautiful hill station."
    },
    {
      "name": "Pune to Shirdi Urbania on Rent",
      description: "AB Ghule Cabs offers Force Urbania for rent from Pune to Shirdi, ideal for pilgrimage trips. With ample space and comfort, our vehicles ensure a smooth and relaxing journey for all passengers."
    },
    {
      "name": "Pune to Mumbai International Airport Urbania on Rent",
      description: "Travel from Pune to Mumbai International Airport in style with a Force Urbania on rent from AB Ghule Cabs. Our spacious and well-maintained vehicles provide a comfortable ride for your airport drop-off or pick-up."
    },
    {
      "name": "Pune to Lonavala Urbania on Rent",
      description: "Book a Force Urbania for your trip from Pune to Lonavala with AB Ghule Cabs. Whether it's a family outing or a group tour, our Urbania vehicles offer comfort and convenience for a smooth journey."
    },
    {
      "name": "Pune to Kolhapur Urbania Hire",
      description: "For a comfortable ride from Pune to Kolhapur, hire a Force Urbania with AB Ghule Cabs. Our vehicles provide ample space and modern amenities to ensure a pleasant journey to your destination."
    },
    {
      "name": "Urbania on Rent in Pimpri Chinchwad",
      description: "AB Ghule Cabs offers Force Urbania for rent in Pimpri Chinchwad, Pune. Whether you're planning a local trip or an outstation journey, our Urbania vehicles provide the perfect solution for group travel."
    },
    {
      "name": "Urbania on Rent in Koregaon Park Pune",
      description: "Need an Urbania on rent in Koregaon Park? AB Ghule Cabs provides Force Urbania vehicles for rent, ideal for group travel and corporate events, with spacious seating and comfortable amenities."
    },
    {
      "name": "Urbania on Rent in Hadapsar",
      description: "Rent a Force Urbania in Hadapsar with AB Ghule Cabs. Our vehicles are perfect for group tours, family outings, or corporate trips, offering plenty of space and comfort for a smooth ride."
    },
    {
      "name": "Urbania on Rent in Kharadi Pune",
      description: "AB Ghule Cabs offers Force Urbania vehicles for rent in Kharadi, Pune. Whether you're traveling locally or to an outstation destination, our Urbania provides the ultimate comfort for large groups."
    },
    {
      "name": "Urbania on Rent in Kothrud Pune",
      description: "Book a Force Urbania on rent in Kothrud with AB Ghule Cabs for your next group trip. Our vehicles are spacious and well-maintained, offering a comfortable ride for both short and long trips."
    },
    {
      "name": "Force Urbania on Rent in Viman Nagar",
      description: "Looking for a Force Urbania on rent in Viman Nagar? AB Ghule Cabs provides high-quality Urbania vehicles for rent, perfect for group travel, corporate events, or special occasions."
    },
    {
      "name": "Force Urbania on Rent in Wagholi Pune",
      description: "AB Ghule Cabs offers Force Urbania for rent in Wagholi, Pune. Our spacious and comfortable vehicles are ideal for group travel, whether you're heading to a local or outstation destination."
    },
    {
      "name": "Pune to Nashik Urbania on Rent",
      description: "Travel in comfort from Pune to Nashik with a Force Urbania on rent from AB Ghule Cabs. Our spacious and well-equipped vehicles ensure a smooth and enjoyable journey for your group."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Urbania on Rent",
      description: "Book a Force Urbania for your Ashtavinayak Darshan trip from Pune. AB Ghule Cabs offers comfortable and spacious Urbania vehicles, ideal for religious trips to multiple temples in the region."
    },
    {
      "name": "Luxury Force Urbania on Rent in Pune Hadapsar",
      description: "For luxury group travel in Pune, AB Ghule Cabs offers the Force Urbania on rent in Hadapsar. With premium features and ample space, our Urbania vehicles are perfect for corporate trips, family outings, or special events."
    },
    {
      "name": "Luxury Force Urbania on Rent in Hinjewadi",
      description: "Rent a luxury Force Urbania in Hinjewadi with AB Ghule Cabs for a stylish and comfortable journey. Our Urbania vehicles are perfect for group travel, ensuring a smooth and luxurious experience."
    },
    {
      "name": "Luxury Force Urbania on Rent in Hinjewadi Near Me",
      description: "AB Ghule Cabs offers a luxury Force Urbania on rent near Hinjewadi, Pune. With spacious seating and modern amenities, our vehicles offer the perfect combination of comfort and style for your group travel needs."
    },
    {
      "name": "Pune to Goa Urbania Bus on Rent",
      description: "Planning a trip to Goa from Pune? Rent a Force Urbania bus from AB Ghule Cabs for a comfortable and spacious group travel experience. Our Urbania buses offer premium amenities for a memorable journey to the beautiful beaches of Goa."
    },
    {
      "name": "Urbania On Rent in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Urbania On Rent in Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],



tableData: [
  ["Luxury Force Urbania On Rent in Pune", "- 13 Seater Force Urbania On Rent in Pune"],
  ["17 Seater Force Urbania On Rent in Pune", "- Force Urbania For Rent in Pune"],
  ["Pune to Mahabaleshwar Urbania Bus On Rent", "- Pune to Shirdi Urbania On Rent"],
  ["Pune to Mumbai International Airport Urbania On Rent", "- Pune to Lonavala Urbania On Rent"],
  ["Pune to Kolhapur Urbania Hire", "- Urbania On Rent in Pimpri Chinchwad"],
  ["Urbania On Rent in Koregaon Park Pune", "- Urbania On Rent in Hadapsar"],
  ["Urbania On Rent in Kharadi Pune", "- Urbania On Rent in Kothrud Pune"],
  ["Force Urbania On Rent in Viman Nagar", "- Force Urbania On Rent in Wagholi Pune"],
  ["Pune to Nashik Urbania On Rent", "- Pune to Ashtavinayak Darshan Urbania On Rent"],
  ["Luxury Force Urbania On Rent in Pune Hadapsar", "- Luxury Force Urbania On Rent in Hinjewadi"],
  ["Luxury Force Urbania On Rent in Hinjewadi Near Me", "- Pune to Goa Urbania Bus On Rent"]
],

whychoose: [
  {
    WhyChooseheading: "Spacious and Comfortable Vehicles",
    WhyChoosedescription: "Our Urbania vehicles offer the perfect combination of spaciousness and comfort for group travel. Whether you need it for a family trip, corporate event, or group tour, the Urbania provides ample legroom, comfortable seating, and air conditioning for a pleasant journey."
  },
  {
    WhyChooseheading: "Experienced and Professional Drivers",
    WhyChoosedescription: "Our drivers are highly trained, experienced, and familiar with all local routes. They are courteous, professional, and committed to ensuring you have a safe and comfortable ride throughout your journey."
  },
  {
    WhyChooseheading: "Well-Maintained Fleet",
    WhyChoosedescription: "All our Urbania vehicles are meticulously maintained and regularly serviced to ensure they are in top-notch condition. Clean, well-maintained, and equipped with modern amenities, our Urbanias provide a smooth and reliable travel experience."
  },
  {
    WhyChooseheading: "Affordable and Transparent Pricing",
    WhyChoosedescription: "We offer competitive pricing for Urbania rentals without compromising on quality. Our pricing structure is clear, with no hidden charges, so you can travel with peace of mind knowing exactly what you’ll pay."
  },
  {
    WhyChooseheading: "Customizable Packages",
    WhyChoosedescription: "We understand that every trip is unique. Whether you need an Urbania for a day trip, a weekend getaway, or a long-distance journey, we offer flexible rental packages tailored to your needs. Let us know your requirements, and we’ll craft the perfect package for you."
  },
  {
    WhyChooseheading: "Safety and Security",
    WhyChoosedescription: "Safety is our top priority. Our Urbania vehicles come equipped with the latest safety features, and our drivers are background-checked to ensure your security during the ride. We also offer GPS tracking for added peace of mind."
  },
  {
    WhyChooseheading: "24/7 Availability",
    WhyChoosedescription: "We are available around the clock to meet your travel needs. Whether you need an Urbania for an early morning ride or a late-night journey, we are always ready to assist with your booking."
  },
  {
    WhyChooseheading: "Easy Booking Process",
    WhyChoosedescription: "Booking an Urbania with AB Ghule Cabs is simple and quick. You can reserve your vehicle via our website, mobile app, or by calling our customer service for assistance. Enjoy a hassle-free booking experience with us."
  }
]

  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book an Urbania in Pune?',
      answer: 'You can book an Urbania vehicle through our website, mobile app, or by calling our customer service team for assistance with your booking.',
    },
    {
      id: 'FAQ2',
      question: 'How many passengers can the Urbania accommodate?',
      answer: 'Our Urbania vehicles are spacious and can comfortably accommodate up to 12-14 passengers, making it ideal for family trips, corporate travel, or group tours.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Urbania air-conditioned?',
      answer: 'Yes, all our Urbania vehicles come equipped with air conditioning to ensure a comfortable ride, especially during long journeys or in warm weather.',
    },
    {
      id: 'FAQ4',
      question: 'What is the cost of renting an Urbania in Pune?',
      answer: 'The cost of renting an Urbania depends on factors like the duration of the trip, distance, and other services required. We offer affordable and transparent pricing with no hidden charges.',
    },
    {
      id: 'FAQ5',
      question: 'Are the drivers experienced and professional?',
      answer: 'Yes, all our drivers are experienced, professional, and thoroughly background-checked. They are well-versed with local routes and committed to providing a safe and smooth journey.',
    },
    {
      id: 'FAQ6',
      question: 'Can I rent an Urbania for outstation travel?',
      answer: 'Yes, we offer Urbania rentals for both local and outstation trips. Whether you\'re traveling to nearby cities or exploring destinations in Maharashtra, our Urbania is a perfect choice for group travel.',
    },
    {
      id: 'FAQ7',
      question: 'How do I make payments for my Urbania rental?',
      answer: 'You can make payment via multiple methods, including cash, credit/debit cards, or online payment through our mobile app.',
    },
    {
      id: 'FAQ8',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, but all such charges are clearly communicated to you before confirming the booking.',
    },
    {
      id: 'FAQ9',
      question: 'Can I cancel or modify my Urbania booking?',
      answer: 'Yes, you can cancel or modify your booking through our website or app. For assistance, you can also contact our customer service team directly.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other Urbania rental services?',
      answer: 'AB Ghule Cabs stands out for its commitment to customer satisfaction, punctuality, well-maintained vehicles, experienced drivers, and transparent pricing. We focus on providing a personalized, safe, and comfortable experience for all your group travel needs.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Anil Gupta',
      feedback: 'We rented an Urbania for a family trip from Pune, and it was a fantastic experience! The vehicle was spacious, clean, and well-maintained. The driver was courteous, professional, and made the whole journey smooth and enjoyable. Highly recommend AB Ghule Cabs for any group travel!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Deshmukh',
      feedback: 'I hired an Urbania for a corporate event, and the service exceeded our expectations. The vehicle was perfect for our group, and the driver was extremely punctual and professional. I will definitely use AB Ghule Cabs for all our future corporate travel needs.',
      rating: 5,
    },
  ];
  
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Urbania on Rent in Pune | Luxury Force Urbania Bus Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Luxury Force Urbania bus rentals in Pune. Offering 13 and 17-seater Force Urbania buses for outstation and local trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Mumbai Airport, and more." />
  <meta name="keywords" content="Luxury Force Urbania on Rent in Pune, 13 Seater Force Urbania on Rent in Pune, 17 Seater Force Urbania on Rent in Pune, Force Urbania for Rent in Pune, Pune to Mahabaleshwar Urbania Bus on Rent, Pune to Shirdi Urbania on Rent, Pune to Mumbai International Airport Urbania on Rent, Pune to Lonavala Urbania on Rent, Pune to Kolhapur Urbania Hire, Urbania on Rent in Pimpri Chinchwad, Urbania on Rent in Koregaon Park Pune, Urbania on Rent in Hadapsar, Urbania on Rent in Kharadi Pune, Urbania on Rent in Kothrud Pune, Force Urbania on Rent in Viman Nagar, Force Urbania on Rent in Wagholi Pune, Pune to Nashik Urbania on Rent, Pune to Ashtavinayak Darshan Urbania on Rent, Luxury Force Urbania on Rent in Pune Hadapsar, Luxury Force Urbania on Rent in Hinjewadi, Luxury Force Urbania on Rent in Hinjewadi Near Me, Pune to Goa Urbania Bus on Rent" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Urbania on Rent in Pune | Luxury Force Urbania Bus Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Luxury Force Urbania bus rentals in Pune. Offering 13 and 17-seater Force Urbania buses for outstation and local trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Mumbai Airport, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/urbania-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/urbania-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Urbania on Rent in Pune",
        description: "Luxury Force Urbania bus rentals in Pune. Offering 13 and 17-seater Force Urbania buses for outstation and local trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Mumbai Airport, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/urbania-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/urbania-rent.jpg",
        "image": "https://abghulecabs.com/images/urbania-rent.jpg",
        "priceRange": "₹3000 - ₹12000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/urbania-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali P"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "Had a wonderful experience with the Urbania rental. Spacious, comfortable, and perfect for our trip to Shirdi."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh M"
            },
            "datePublished": "2024-10-25",
            "reviewBody": "Best service for outstation trips. The Force Urbania is very comfortable for long journeys. Highly recommended."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Urbania Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/urbania-on-rent-in-pune"
        },
        "keywords": "Luxury Force Urbania on Rent in Pune, 13 Seater Force Urbania on Rent in Pune, 17 Seater Force Urbania on Rent in Pune, Force Urbania for Rent in Pune, Pune to Mahabaleshwar Urbania Bus on Rent, Pune to Shirdi Urbania on Rent, Pune to Mumbai International Airport Urbania on Rent, Pune to Lonavala Urbania on Rent, Pune to Kolhapur Urbania Hire, Urbania on Rent in Pimpri Chinchwad, Urbania on Rent in Koregaon Park Pune, Urbania on Rent in Hadapsar, Urbania on Rent in Kharadi Pune, Urbania on Rent in Kothrud Pune, Force Urbania on Rent in Viman Nagar, Force Urbania on Rent in Wagholi Pune, Pune to Nashik Urbania on Rent, Pune to Ashtavinayak Darshan Urbania on Rent, Luxury Force Urbania on Rent in Pune Hadapsar, Luxury Force Urbania on Rent in Hinjewadi, Luxury Force Urbania on Rent in Hinjewadi Near Me, Pune to Goa Urbania Bus on Rent"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/39.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Urbaniaonrentinpune;